import styled from '@emotion/styled';
import { ClassAttributes, createElement } from 'react';

import EditStatusIcon from '../EditStatusIcon';

interface Props {
  done: boolean;
  exists: boolean;
  isCanceled: boolean;
  className?: string;
}

const ModificationStatusIcon = ({ done, exists, isCanceled, className }: ClassAttributes<HTMLElement> & Props) => {
  if (isCanceled || !exists) {
    return null;
  }

  return <Root done={done} className={className} />;
};

const Root = styled(EditStatusIcon)();

export default ModificationStatusIcon;
